module.exports = __webpack_public_path__ + "static/patagonia_737x514-3e8b21484d4bbb86eaae40b6f64f27bb.webp";